module.exports = __webpack_public_path__ + "static/media/dashboard.d2fe475c.jpg";